export const TALENT = [
  {
    slug: "shannon-ivey",
    name: "Shannon Ivey",
    role: "Speaker, Coach & Author",
    focus:
      "Story strategy, public speaking, applied theatre, and survivorship. 2x TEDx speaker. Founder and Chief Story Officer of #whatshesaidproject.",
    expertise: [
      "Story Strategy & Platform Development",
      "Public Speaking & Keynotes",
      "Applied Theatre & Theatre of the Oppressed",
      "Survivorship & Health Storytelling",
    ],
    img: "https://images.squarespace-cdn.com/content/v1/672a48b558540252c5213760/5b08126f-9ffb-4397-bbf2-639dfdfd7710/IMG_0197.jpeg",
    caption: "Shannon Ivey / Speaker, Coach & Author",
  },
  {
    slug: "d-nichole-davis",
    name: "D. Nichole Davis",
    role: "Speaker, Leader & Author",
    focus:
      "Leadership, professional development, and stroke survivorship. Delivering transformative keynotes on resilience, executive growth, and human-centered leadership.",
    expertise: [
      "Leadership & Executive Growth",
      "Professional Development",
      "Stroke Survivorship & Resilience",
      "Human-Centered Leadership",
    ],
    img: "https://www.dnicholedavis.com/assets/about-portrait-kDmb5S-8.jpg",
    caption: "D. Nichole Davis / Speaker, Leader & Author",
  },
  {
    slug: "jenn-wilenta",
    name: "Jenn Wilenta",
    role: "Dancer, Educator & Speaker",
    focus:
      "Trauma & healing. Honest conversations about what it means not only to survive trauma, but to rebuild a life after it.",
    expertise: [
      "Healing Through Movement",
      "Sexual Assault & Drug-Facilitated Rape",
      "Education & Empowerment",
      "Community & Change",
    ],
    img: "https://images.squarespace-cdn.com/content/v1/6a2184e15ceea5553bc34d54/c7c27c5a-c0a1-4612-8675-be6ab6ab2085/IMG_6453.jpg",
    caption: "Jenn Wilenta / Dancer, Educator & Speaker",
  },
];
